import { MutationTree } from 'vuex';
import { State } from '@/core/store/auth/state';

export interface Mutations {
    authRequest: {};
    authSuccess: {token: string};
    authError: {};
    authLogout: {};
    setProfile: {};
    userPermissions:{};
}

export const mutations: MutationTree<State> = {
    authRequest: (state) => {
        state.status = 'loading';
    },
    authSuccess: (state, payload) => {
        state.status = 'success';
        state.token = payload.token;
    },
    authError: (state) => {
        state.status = 'error';
    },
    authLogout: (state) => {
        state.status = '';
        state.token = '';
    },
    setProfile: (state, payload) => {
        state.profile = payload;
    },
    setUserPermissions: (state, permissions) => {
        state.userPermissions = permissions;
    },
};
